import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../config/firebase';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage('Check your email for a password reset link.');
    } catch (err) {
      console.error('Password reset error:', err);
      if (err.code === 'auth/user-not-found') {
        setError('No account found with this email.');
      } else if (err.code === 'auth/invalid-email') {
        setError('Invalid email address.');
      } else {
        setError('Failed to send reset email. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      background: '#f8fafc'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '420px',
        background: '#ffffff',
        borderRadius: '12px',
        padding: '48px 40px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
      }}>
        {/* Logo */}
        <div style={{ marginBottom: '32px', textAlign: 'center' }}>
          <img 
            src="/pulse_blue.png" 
            alt="Pulse" 
            style={{ height: '48px' }}
          />
        </div>

        {/* Title */}
        <h1 style={{
          fontSize: '24px',
          fontWeight: 600,
          color: '#0D1B2A',
          margin: '0 0 8px 0',
          textAlign: 'center'
        }}>
          Forgot password
        </h1>
        
        <p style={{
          fontSize: '15px',
          color: '#64748b',
          margin: '0 0 32px 0',
          textAlign: 'center'
        }}>
          Enter your email address and we'll send you a link to reset your password.
        </p>

        {/* Success Message */}
        {message && (
          <div style={{
            padding: '12px 16px',
            marginBottom: '20px',
            background: '#f0fdf4',
            border: '1px solid #bbf7d0',
            borderRadius: '8px',
            color: '#16a34a',
            fontSize: '14px',
            textAlign: 'center'
          }}>
            {message}
          </div>
        )}

        {/* Error Message */}
        {error && (
          <div style={{
            padding: '12px 16px',
            marginBottom: '20px',
            background: '#fef2f2',
            border: '1px solid #fecaca',
            borderRadius: '8px',
            color: '#dc2626',
            fontSize: '14px',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '24px' }}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email address"
              required
              style={{
                width: '100%',
                padding: '14px 16px',
                fontSize: '16px',
                border: '1px solid #e2e8f0',
                borderRadius: '10px',
                outline: 'none',
                transition: 'border-color 0.2s, box-shadow 0.2s',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#E63946';
                e.target.style.boxShadow = '0 0 0 3px rgba(230, 57, 70, 0.1)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#e2e8f0';
                e.target.style.boxShadow = 'none';
              }}
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '14px 24px',
              fontSize: '16px',
              fontWeight: 600,
              color: '#ffffff',
              background: loading ? '#f87171' : '#E63946',
              border: 'none',
              borderRadius: '10px',
              cursor: loading ? 'default' : 'pointer',
              transition: 'background 0.2s',
              marginBottom: '24px'
            }}
          >
            {loading ? 'Sending...' : 'Send reset link'}
          </button>
        </form>

        {/* Divider */}
        <div style={{
          textAlign: 'center',
          color: '#94a3b8',
          fontSize: '14px',
          marginBottom: '24px'
        }}>
          Or
        </div>

        {/* Back to Login */}
        <Link
          to="/login"
          style={{
            display: 'block',
            width: '100%',
            padding: '14px 24px',
            fontSize: '16px',
            fontWeight: 500,
            color: '#374151',
            background: '#ffffff',
            border: '1px solid #e2e8f0',
            borderRadius: '10px',
            textAlign: 'center',
            textDecoration: 'none',
            boxSizing: 'border-box',
            transition: 'background 0.2s'
          }}
        >
          Login
        </Link>
      </div>
    </div>
  );
}

export default ForgotPassword;